import { BaseBudget } from 'typings'
import { useFormStateContext } from 'ui'
import { MoreForLessPromotion } from '../../typings'
import { Summary } from './Summary'
import { Alerts } from './Summary/Alerts'

export function MoreForLess() {
  const { form, discountType } = useFormStateContext()

  const {
    conditions,
    general,
    restrictions,
    scheduling,
    moreForLess,
  }: MoreForLessPromotion = form.getValues()

  return (
    <>
      <Alerts>
        <Alerts.MoreForLessRecap moreForLess={moreForLess} />
        <Alerts.AffectedProducts />
      </Alerts>

      <Summary.Container>
        <Summary.Name name={general.name} />
        <Summary.Scheduling scheduling={scheduling} />
        <Summary.SalesChannels salesChannels={restrictions.salesChannels} />
        <Summary.Budget
          budget={restrictions.budget as BaseBudget | undefined}
        />
        <Summary.Sellers sellers={restrictions.sellers} />
        <Summary.MoreForLess benefit={moreForLess.benefit} />
        <Summary.Conditions conditions={conditions} />
        <Summary.Restrictions restrictions={restrictions} />
        <Summary.Accumulate
          restrictions={restrictions}
          discountType={discountType}
        />
      </Summary.Container>
    </>
  )
}
